import Client from './Clients/AxiosClient'
const resource = 'files'

export default {
  uploadAvatar (payload) {
    payload['body'] = payload['body'].replace(/^data:image\/\w+;base64,/, '')
    return Client.post(`${resource}/avatar`, payload)
      .then(response => response.data)
  },
  uploadAccountBrand (payload) {
    payload['body'] = payload['body'].replace(/^data:image\/\w+;base64,/, '')
    return Client.post(`${resource}/account_brand`, payload)
      .then(response => response.data)
  },
  uploadAccountImage (payload) {
    payload['body'] = payload['body'].replace(/^data:image\/\w+;base64,/, '')
    return Client.post(`${resource}/account_image`, payload)
      .then(response => response.data)
  },
  uploadProductImage (payload) {
    payload['body'] = payload['body'].replace(/^data:image\/\w+;base64,/, '')
    return Client.post(`${resource}/product_image`, payload)
      .then(response => response.data)
  },
  getPresignedPut () {
    return Client.get(`${resource}/presigned_upload_put`)
      .then(response => response.data)
  },
  getProofCoverImage (key, bucket) {
    return Client.post(`${resource}/proof_cover_image`, { key, bucket })
      .then(response => response.data)
  },
  uploadPersonalizationOrderNames (filename, data) {
    return Client.post(`${resource}/upload_personalization_order_names`, { filename, data })
      .then(response => response.data)
  },
  getPresignedPersonalizationPut (orderExternalId) {
    return Client.get(`${resource}/presigned_personalization_upload_put?external_id=${orderExternalId}`)
      .then(response => response.data)
  }
}
